'use client';

import { c as _c } from "react/compiler-runtime";
import { Brain, ClipboardText, UserMinus } from '@phosphor-icons/react';
import { PROBLEM_STATS } from '@/src/constants/Research';
const cardStyles = [{
  bg: '#F0F9FF',
  color: '#0284C7',
  icon: <Brain weight="duotone" size={28} color="#0284C7" />
}, {
  bg: '#FFFBEB',
  color: '#D97706',
  icon: <UserMinus weight="duotone" size={28} color="#D97706" />
}, {
  bg: '#F0FDF9',
  color: '#059669',
  icon: <ClipboardText weight="duotone" size={28} color="#059669" />
}];
export const ResearchProblem = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-center text-2xl font-medium text-[#3D3E40] md:text-3xl">The Problem We're Solving</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mx-auto mt-4 max-w-3xl space-y-3 text-center text-[15px] text-[#616366] md:text-base"><p>Special education teachers are drowning in paperwork. Medicaid billing, manual data collection, hand-built progress graphs, and duplicative documentation consume hours every week — hours that should be spent teaching.</p><p>This isn't just an inconvenience. Research shows that administrative burden is the primary driver of emotional exhaustion in special education, and burnout is the strongest predictor of teachers leaving the profession entirely.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="py-16 md:py-24"><div className="container mx-auto px-6 md:px-10 2xl:px-[10rem]">{t0}{t1}<div className="mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-5 sm:grid-cols-3">{PROBLEM_STATS.map(_temp)}</div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(stat, i) {
  const style = cardStyles[i];
  return <div key={stat.source} className="flex flex-col gap-4 rounded-2xl p-6" style={{
    backgroundColor: style.bg
  }}>{style.icon}<div className="text-4xl font-bold leading-none" style={{
      color: style.color
    }}>{stat.value}</div><p className="text-sm font-medium leading-snug text-[#3D3E40]">{stat.label}</p><p className="mt-auto text-xs italic text-[#616366]">{stat.source}</p></div>;
}